window.BLX = (function(BLX) {
	var constructURLFromParts = function(url, origin, preserveFragment) {
		// Regular exp
		var fullURLRe = /^(https?):\/\/([^\/?#]+)(\/[^?#]*)?(\?[^#]*)?(#.*)?$/;
		var onlyPathRe = /^([^?#]*)(\?[^#]*)?(#.*)?$/;

		// The origin should be a full URL. Of course, if url is a full URL, we don't need the origin.
		if (fullURLRe.test(url))
			return url;

		if (onlyPathRe.test(url) && url.substring(0, 2) == '//') {
			// If the URL begins '//', it's missing the protocol specifier. I hate these, but the assumption
			// is that '//www.google.com/' is actually '<current protocol>://www.google.com/'.
			var originItems = origin.match(fullURLRe);
			return originItems[1] + ':' + url;
		}
	
		var originItems = origin.match(fullURLRe);
		var urlParts = {
			scheme: originItems[1],
			host: originItems[2],
			path: originItems[3] || '',
			query: originItems[4] || '',
			frag: originItems[5] || ''
		}
	
		// We've already excluded a 'full' URL at this point.
		var parsedItems = url.match(onlyPathRe);
		urlParts.query = parsedItems[2] || '';
		urlParts.frag = parsedItems[3] || '';
		if (parsedItems[1].charAt(0) == '/')
			urlParts.path = parsedItems[1];
		else {
			var oldPath = urlParts.path.split('/').filter(function(v) { return !!v });
			var newPath = parsedItems[1].split('/').filter(function(v) { return !!v });
			if (urlParts.path.charAt(urlParts.path.length - 1) != '/' && newPath.length) oldPath.pop();
			
			var nextItem;
			while (nextItem = newPath.shift()) {
				if (nextItem == '.') continue;
				else if (nextItem == '..') oldPath.pop();
				else oldPath.push(nextItem);
			}
			urlParts.path = '/' + oldPath.join('/') + (parsedItems[1].charAt(parsedItems[1].length - 1) == '/' ? '/' : '');
		}
		
		// We're stripping fragment identifiers here. We don't care about those.
		return urlParts.scheme + '://' + urlParts.host + urlParts.path + urlParts.query + (preserveFragment ? urlParts.frag : '');
	}
	
	BLX.localHref = function(value) {
		return constructURLFromParts(value, location.href, true);
	}
	
	BLX.setupLocalHref = function() {
		$('[data-local-href]').each(function() {
			$(this).attr('href', constructURLFromParts($(this).attr('data-local-href'), location.href, true));
		});
	}
	
	BLX.reloadStylesheet = function() {
		$('link[rel=stylesheet]:eq(0)').attr('href', 'css/main-website.css?_=' + new Date().getTime());
	}
	
	var closeButtonContent = "<button type='button' class='close' data-dismiss='modal' aria-label='Close'><span class='glyphicons glyphicons-circle-remove'></span></button>";
	BLX.setModalCloseButton = function(text) { closeButtonContent = text; }
	BLX.modalCloseButton = function() { return closeButtonContent; }
	
	var scrollBox = document.createElement('div');
	$(scrollBox).css({overflow: 'scroll', position: 'fixed', top: '-1000px', left: '-1000px', width: '100px', height: '100px'});
	
	var scrollbarsVisible = null;
	
	function setScrollbars() {
		var hsb = scrollBox.clientWidth < scrollBox.offsetWidth;
		if (hsb !== scrollbarsVisible) {
			scrollbarsVisible = hsb;
			if (scrollbarsVisible) $('body').removeClass('no-scrollbars');
			else $('body').addClass('no-scrollbars');
		}
	}
	$(window).on('resize', setScrollbars);

	BLX.setLinkToModal = function(selector, target) {
		$(selector).on('click', function() {
			$(target).modal('show');
			return false;
		});
	}

	$(function() {
		$('body').append(scrollBox);
		
		setScrollbars();
	})
	
	return BLX;
})(window.BLX || {});

window.React = require('react');
window.ReactDOM = require('react-dom');

